<template>
  <div class="wrap">
    <Nav fixed safeAreaInsetTop placeholder />
    <div class="content">
      <div class="header_title">{{ $t('user.basicInformation') }}</div>
      <!-- <div class="imgs_list">
        <div class="img_upload">
          <div class="upload_index">1</div>
          <div class="upload_text">{{ $t('uplaodIdCard') }}</div>
          <div class="upload">
            <van-uploader v-model="card_front" :after-read="card_frontUpload" :show-upload="card_front.length === 0"
              @delete="deleteImage('card_front')">
              <img class="upload_img" src="../../assets/new/identity.png" alt="">
            </van-uploader>
          </div>
        </div>
        <div class="img_upload">
          <div class="upload_index">2</div>
          <div class="upload_text">{{ $t('uploadBackIdCard') }}</div>
          <div class="upload">
            <van-uploader v-model="card_back" :after-read="card_backUpload" :show-upload="card_back.length === 0"
              @delete="deleteImage('card_bank')">
              <img class="upload_img" src="../../assets/new/identity-back.png" alt="">
            </van-uploader>
          </div>
        </div>
        <div class="img_upload">
          <div class="upload_index">3</div>
          <div class="upload_text">{{ $t('uploadHolder') }}</div>
          <div class="upload">
            <van-uploader v-model="card_hand" :after-read="card_handUpload" :show-upload="card_hand.length === 0"
              @delete="deleteImage('card_hand')">
              <img class="upload_img" src="../../assets/new/identity-handhold.png" alt="">
            </van-uploader>
          </div>
        </div>
      </div> -->
      <div class="form">
        <div class="userInfo">
          <div class="info_item">
            <div class="label">{{ $t('fullName') }}:</div>
            <van-field v-model="form.name" label-width="0" :placeholder="$t('fullNamePlaceholder')" />
          </div>
          <div class="info_item">
            <div class="label">{{ $t('idNumber') }}:</div>
            <van-field v-model="form.idcard" label-width="0" :placeholder="$t('idNumberPlaceholder')" />
          </div>
          <div class="info_item gender">
            <div class="label">{{ $t('gender') }}:</div>
            <van-radio-group v-model="form.gender" direction="horizontal">
              <van-radio name="1">{{ $t('male') }}</van-radio>
              <van-radio name="0">{{ $t('female') }}</van-radio>
            </van-radio-group>
          </div>
          <div class="info_item">
            <div class="label">{{ $t('birthday') }}:</div>
            <van-field :value="$format(form.birthday, 'dd/MM/yyyy')" readonly label-width="0"
              :placeholder="$t('idNumberPlaceholder')" @click="birthdayShow = true">
              <template #right-icon>
                <van-icon name="arrow" size="18" color="#7972e6" />
              </template>
            </van-field>
            <van-popup v-model="birthdayShow" position="bottom" class="birthday_pop">
              <van-datetime-picker v-model="form.birthday" :minDate="minDate" type="date" :title="$t('birthdayTitle')"
                :confirm-button-text="$t('user.Button.Two')" :cancel-button-text="$t('user.Button.One')"
                @cancel="birthdayShow = false" @confirm="birthdayConfirm" />
            </van-popup>
          </div>
          <div class="info_item">
            <div class="label">{{ $t('maritalStatus') }}:</div>
            <van-field :value="$t(maritalColumns[form.maritalStatus].text)" readonly label-width="0"
              @click="maritalStatusShow = true">
              <template #right-icon>
                <van-icon name="arrow" size="18" color="#7972e6" />
              </template>
            </van-field>
            <van-popup v-model="maritalStatusShow" position="bottom" class="birthday_pop">
              <van-picker :default-index="form.maritalStatus" show-toolbar :confirm-button-text="$t('user.Button.Two')"
                :cancel-button-text="$t('user.Button.One')" :columns="maritalColumns" @confirm="maritalStatusConfirm"
                @cancel="maritalStatusShow = false">
                <template #option="option">
                  {{ $t(option.text) }}
                </template>
              </van-picker>
            </van-popup>
          </div>
          <div class="info_item">
            <div class="label">{{ $t('education') }}:</div>
            <van-field :value="$t(educationColumns[form.education].text)" readonly label-width="0"
              @click="educationShow = true">
              <template #right-icon>
                <van-icon name="arrow" size="18" color="#7972e6" />
              </template>
            </van-field>
            <van-popup v-model="educationShow" position="bottom" class="birthday_pop">
              <van-picker :default-index="form.maritalStatus" show-toolbar :confirm-button-text="$t('user.Button.Two')"
                :cancel-button-text="$t('user.Button.One')" :columns="educationColumns" @confirm="educationConfirm"
                @cancel="educationShow = false">
                <template #option="option">
                  {{ $t(option.text) }}
                </template>
              </van-picker>
            </van-popup>
          </div>
          <div class="info_item">
            <div class="label">{{ $t('email') }}:</div>
            <van-field v-model="form.email" label-width="0" :placeholder="$t('emailPlaceholder')" />
          </div>
          <!-- <div class="info_item">
            <div class="label">{{ $t('facebookLink') }}:</div>
            <van-field v-model="form.faceCard" label-width="0" :placeholder="$t('facebookLinkPlaceholder')" />
          </div> -->
          <div class="province_city">
            <div class="info_item">
              <div class="label">{{ $t('province') }}:</div>
              <van-field v-model="form.province" label-width="0" :placeholder="$t('facebookLinkPlaceholder')" />
            </div>
            <div class="info_item">
              <div class="label">{{ $t('city') }}:</div>
              <van-field v-model="form.city" label-width="0" :placeholder="$t('facebookLinkPlaceholder')" />
            </div>
          </div>
          <div class="info_item">
            <div class="label">{{ $t('address') }}:</div>
            <van-field v-model="form.address" label-width="0" :placeholder="$t('addressPlaceholder')" />
          </div>
        </div>
        <div class="userInfo bankcard">
          <div class="title">{{ $t('bankAccountNumber') }}</div>
          <div class="info_item">
            <div class="label">{{ $t('bank') }}:</div>
            <van-field v-model="form.bank" label-width="0" :placeholder="$t('bankPlaceholder')" />
          </div>
          <div class="info_item">
            <div class="label">{{ $t('bankNumber') }}:</div>
            <van-field v-model="form.card" label-width="0" :placeholder="$t('bankNumber')" />
          </div>
        </div>
        <!-- <div class="userInfo userInfo_loan">
          <div class="title">{{ $t('loan') }}</div>
          <div class="info_item">
            <div class="label">{{ $t('loanAmount') }}:</div>
            <van-field v-model="form.money" label-width="0" :placeholder="$t('请输入贷款金额')" />
          </div>
          <div class="info_item">
            <div class="label">{{ $t('terms') }}:</div>
            <div class="expect">
              <div class="expect_item" :class="form.expect == item.expect ? 'active' : ''"
                v-for="(item, index) in expectList" :key="index" @click="itemClick(item)">
                {{ item.expect }}
              </div>
            </div>
          </div>
          <div class="loan">
            <div class="loan_item">
              <div class="label">{{ $t('applicationAmount') }}:</div>
              <div class="value">{{ form.money }}</div>
            </div>
            <div class="loan_item">
              <div class="label">{{ $t('installmentAmount') }}:</div>
              <div class="value">{{ getMoney() }}</div>
            </div>
            <div class="loan_item">
              <div class="label">{{ $t('interestRate') }}:</div>
              <div class="value">{{ rate.rate || 0 }}%</div>
            </div>
            <div class="loan_item">
              <div class="label">{{ $t('terms') }}:</div>
              <div class="value">{{ form.expect }}</div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="btn" @click="confirm">{{ $t('next') }}</div>
    </div>
  </div>
</template>
<script>
import { Icon, Toast, Uploader, Field, RadioGroup, Radio, DatetimePicker, Overlay, Popup, Picker } from "vant";
import Nav from "@/components/Navbar";
import { $upload } from "@/utils/request";
import { USER_LEVELAUTH } from "@/api";
import { mapGetters } from "vuex"
export default {
  components: {
    [Icon.name]: Icon,
    Nav,
    [Uploader.name]: Uploader,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [DatetimePicker.name]: DatetimePicker,
    [Overlay.name]: Overlay,
    [Popup.name]: Popup,
    [Picker.name]: Picker
  },
  data() {
    return {
      card_front: [],
      card_back: [],
      card_hand: [],
      formData: {},
      minDate: new Date(1900, 0, 1),
      form: {
        level: 1,
        name: '',
        idcard: '',
        bank: '',
        card: '',
        gender: '1',
        birthday: new Date(),
        maritalStatus: 0,
        education: 0,
        email: '',
        // faceCard: '',
        province: '',
        city: '',
        address: '',
        // money: '',
        // expect: ''
      },
      birthdayShow: false,
      maritalStatusShow: false,
      maritalColumns: [{ text: "single", value: 0 }, { text: "married", value: 1 }, { text: "divorced", value: 2 }, { text: "widowed", value: 3 }],
      educationColumns: [{ text: "juniorHigh", value: 0 }, { text: "middleSchool", value: 1 }, { text: "highSchool", value: 2 }, { text: "graduateAbove", value: 3 }, { text: "none", value: 4 }],
      educationShow: false,
    }
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapGetters(["userInfo"]),
    expectList() {
      const obj = this.userInfo.credit_rank || {};
      let expects = obj.expect || {}
      let arr = Object.entries(expects);
      const resultArray = arr.length && arr.map(([key, value]) => ({
        expect: Number(key),
        rate: value
      }));
      return resultArray || []
    },
    rate() {
      const item = this.expectList.length && this.expectList.find(val => val.expect == this.form.expect)
      return item || {}
    }
  },
  methods: {
    itemClick(item) {
      if (this.form.expect == item.expect) {
        return this.form.expect = "";
      }
      this.form.expect = item.expect;
      if (!this.form.money) {
        this.form.money = this.userInfo.credit_rank.min_money;
      }
      this.getMoney();
    },
    getMoney() {
      let num = this.form.money * (1 + Number(this.rate.rate || 0) / 12 / 100 * this.form.expect) / this.form.expect;
      const new_num = num == 'Infinity' || num == 'NaN' ? 0 : num;
      return Number(new_num.toFixed(2)) || 0;
    },
    confirm() {
      // if (!this.formData.card_front) return this.$toast(this.$t('uplaodIdCard'));
      // if (!this.formData.card_back) return this.$toast(this.$t('uploadBackIdCard'));
      // if (!this.formData.card_hand) return this.$toast(this.$t('uploadHolder'));
      if (!this.form.name) return this.$toast(this.$t('fullNameError'));
      if (!this.form.idcard) return this.$toast(this.$t('idNumberError'));
      if (!this.form.email) return this.$toast(this.$t('emailError'));
      // if (!this.form.faceCard) return this.$toast(this.$t('facebookError'));
      if (!this.form.province) return this.$toast(this.$t('provinceError'));
      if (!this.form.city) return this.$toast(this.$t('cityError'));
      if (!this.form.address) return this.$toast(this.$t('addressPlaceholder'));
      if (!this.form.bank) return this.$toast(this.$t('bankError'));
      if (!this.form.card) return this.$toast(this.$t('bankNumberError'));
      // if (!this.form.money) return this.$toast(this.$t('请输入贷款金额'));
      // if (!this.form.expect) return this.$toast(this.$t('请选择分期'))
      this.setLevelAuth();
    },
    birthdayConfirm(item) {
      this.birthdayShow = false;
    },
    maritalStatusConfirm(item) {
      this.form.maritalStatus = item.value;
      this.maritalStatusShow = false;
    },
    educationConfirm(item) {
      this.form.education = item.value;
      this.educationShow = false
    },
    deleteImage(which) {
      (this[which] = []), (this.formData[which] = "");
    },
    readImg(file) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        const reader = new FileReader()
        reader.onload = function (e) {
          img.src = e.target.result
        }
        reader.onerror = function (e) {
          reject(e)
        }
        reader.readAsDataURL(file)
        img.onload = function () {
          resolve(img)
        }
        img.onerror = function (e) {
          reject(e)
        }
      })
    },
    async compressImg(file) {
      const img = await this.readImg(file);
      const type = img.type;
      return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        const { width: originWidth, height: originHeight } = img;
        const maxWidth = 1000
        const maxHeight = 1000
        let targetWidth = originWidth
        let targetHeight = originHeight
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > 1) {
            targetWidth = maxWidth
            targetHeight = Math.round(maxWidth * (originHeight / originWidth))
          } else {
            targetHeight = maxHeight
            targetWidth = Math.round(maxHeight * (originWidth / originHeight))
          }
        }
        canvas.width = targetWidth
        canvas.height = targetHeight
        context.clearRect(0, 0, targetWidth, targetHeight)
        context.drawImage(img, 0, 0, targetWidth, targetHeight)
        canvas.toBlob(function (blob) {
          resolve(blob)
        }, type || 'image/png')
      })
    },
    async card_frontUpload(event) {
      event.status = 'uploading';
      event.message = this.$t("upload.uploading");
      const formdata = new FormData();
      try {
        const ImgData = await this.compressImg(event.file);
        const fileData = new File([ImgData], event.file.name, { type: ImgData.type })
        formdata.append("image", fileData);
      } catch (error) {
        formdata.append("image", event.file);
      }
      $upload({ url: "/users/upload", data: formdata }).then((res) => {
        if (res.ret === 1) {
          event.status = 'success';
          event.message = '';
          this.formData.card_front = res.data.path;
        } else {
          event.status = 'failed';
          event.message = this.$t("upload.failed");
        }
      }).catch((err) => {
        event.status = 'failed';
        event.message = this.$t("upload.failed");
      });
    },
    async card_backUpload(event) {
      event.status = 'uploading';
      event.message = this.$t("upload.uploading");
      const formdata = new FormData();
      try {
        const ImgData = await this.compressImg(event.file);
        const fileData = new File([ImgData], event.file.name, { type: ImgData.type })
        formdata.append("image", fileData);
      } catch (error) {
        formdata.append("image", event.file);
      }
      $upload({ url: "/users/upload", data: formdata }).then((res) => {
        if (res.ret === 1) {
          event.status = 'success';
          event.message = '';
          this.formData.card_back = res.data.path;
        } else {
          event.status = 'failed';
          event.message = this.$t("upload.failed");
        }
      }).catch((err) => {
        event.status = 'failed';
        event.message = this.$t("upload.failed");
      });
    },
    async card_handUpload(event) {
      event.status = 'uploading';
      event.message = this.$t("upload.uploading");
      const formdata = new FormData();
      try {
        const ImgData = await this.compressImg(event.file);
        const fileData = new File([ImgData], event.file.name, { type: ImgData.type })
        formdata.append("image", fileData);
      } catch (error) {
        formdata.append("image", event.file);
      }
      $upload({ url: "/users/upload", data: formdata }).then((res) => {
        if (res.ret === 1) {
          event.status = 'success';
          event.message = '';
          this.formData.card_hand = res.data.path;
        } else {
          event.status = 'failed';
          event.message = this.$t("upload.failed");
        }
      }).catch((err) => {
        event.status = 'failed';
        event.message = this.$t("upload.failed");
      });
    },
    async getData() {
      try {
        const res = await USER_LEVELAUTH({});
        if (res.data.auth_data) {
          let birthdays = res.data.auth_data && res.data.auth_data.birthday.split('-')
          let month = birthdays[1] - 0;
          month = month != 0 ? month - 1 : month
          month = month < 10 ? '0' + month : month
          birthdays[1] = month
          let newBirthday = new Date(birthdays[0], birthdays[1], birthdays[2]);
          this.form = { ...this.form, ...res.data.auth_data || {}, birthday: new Date(newBirthday) }
          this.card_front = [{ url: this.$img(this.form.card_front) }];
          this.card_back = [{ url: this.$img(this.form.card_back) }];
          this.card_hand = [{ url: this.$img(this.form.card_hand) }]
          this.formData.card_front = this.form.card_front;
          this.formData.card_back = this.form.card_back;
          this.formData.card_hand = this.form.card_hand;
        }
      } catch (error) { }
    },
    async setLevelAuth() {
      try {
        const res = await USER_LEVELAUTH({ ...this.form, birthday: this.$format(this.form.birthday, 'dd/MM/yyyy'), ...this.formData });
        this.$router.push('/question')
      } catch (error) {
        this.$toast(error.msg)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background-color: var(--nav-background);
  display: flex;
  flex-direction: column;

  .content {
    padding: calc(15rem / 16);
    padding-bottom: calc(90rem / 16);

    .header_title {
      color: var(--white);
      text-align: center;
      display: block;
      font-size: calc(28rem / 16);
      font-weight: 700;
      padding-bottom: calc(15rem / 16);
    }

    .imgs_list {
      display: flex;
      flex-wrap: wrap;
      border-radius: calc(10rem / 16);
      background: url(../../assets/new/identity-bg.png) no-repeat;
      background-color: #f39200;
      background-size: contain;
      background-position: bottom;
      justify-content: center;

      .img_upload {
        width: calc(50% - 20rem / 16);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: calc(10rem / 16);
        color: var(--white);

        .upload_index {
          font-size: calc(28rem / 16);
          font-weight: 700;
        }

        .upload_text {
          margin: calc(5rem / 16) 0 calc(10rem /16);
          font-size: calc(14rem / 16);
        }

        .upload {
          &_img {
            width: 100%;
            border-radius: calc(8rem / 16);
            display: block;
          }

          /deep/ .van-uploader__preview {
            margin: 0;

            .van-uploader__preview-image {
              width: 100%;
              height: 100%;
              border-radius: calc(8rem / 16);
              display: block;
              overflow: hidden;
            }

            .van-uploader__preview-delete {
              border-radius: 0 calc(8rem / 16) 0 calc(8rem / 16);
              width: calc(18rem / 16);
              height: calc(18rem / 16);

              &-icon {
                font-size: calc(20rem / 16);
              }
            }
          }
        }
      }
    }

    .form {
      .userInfo {
        margin-top: calc(10rem / 16);
        padding: calc(10rem / 16);
        border-radius: calc(10rem / 16);
        color: var(--white);
        background: url(../../assets/new/baseInfo-bg.png) no-repeat;
        background-color: #fbb350;
        background-size: contain;
        background-position: bottom;

        .info_item {
          margin: calc(20rem / 16) 0;

          .label {
            padding-bottom: calc(10rem / 16);
            font-size: calc(14rem / 16);
          }

          /deep/ .van-cell {
            height: calc(45rem / 16);
            line-height: calc(45rem / 16);
            padding: 0 calc(16rem / 16);
            border-radius: calc(5rem / 16);

            .van-field__body {
              input {
                color: #606266;
                font-size: calc(14rem / 16);
              }
            }
          }

          .birthday_pop {
            border-radius: calc(16rem / 16) calc(16rem / 16) 0 0;

            /deep/ .van-picker__title {
              color: var(--black);
              font-size: calc(16rem / 16);
            }
          }
        }

        .province_city {
          display: flex;
          column-gap: calc(20rem / 16);

          .info_item {
            margin: 0;
          }
        }

        .gender {
          display: flex;
          align-items: center;
          justify-content: space-between;

          /deep/ .van-radio-group {
            padding-bottom: calc(10rem / 16);

            .van-radio__icon {
              font-size: calc(14rem / 16);
            }

            .van-radio__icon--checked .van-icon {
              color: var(--moduleColor);
              background-color: var(--white);
              border-color: var(--white);
            }

            .van-radio__label {
              color: var(--white);
              font-size: calc(14rem / 16);
            }
          }
        }
      }

      .bankcard {
        background: url(../../assets/new/bankcard-bg.png) no-repeat;
        background-size: cover;
        background-position: bottom;

        .title {
          margin: calc(10rem / 16) 0;
          text-align: center;
          padding: 0 calc(10rem / 16);
          font-weight: 700;
          font-size: calc(16rem / 16);
          text-align: center;
          color: var(--white);
        }
      }

      .userInfo_loan {
        background: #fbb350;

        .title {
          margin: calc(10rem / 16) 0;
          text-align: center;
          padding: 0 calc(10rem / 16);
          font-weight: 700;
          font-size: calc(16rem / 16);
          text-align: center;
          color: var(--white);
        }

        .expect {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: space-around;
          gap: calc(16rem / 16);
          // margin-top: calc(20rem / 16);

          &_item {
            flex: 1;
            padding: calc(10rem / 16);
            border-radius: calc(4rem / 16);
            border: 2px solid var(--white);
            color: var(--theme);
            text-align: center;
            font-size: calc(16rem / 16);
          }

          .active {
            background-color: var(--white);
            color: #fbb350;
          }
        }

        .loan {
          background-color: var(--white);
          border-radius: calc(4rem / 16);
          margin-top: calc(20rem / 16);

          &_item {
            padding: calc(5rem / 16) calc(10rem / 16);
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: calc(14rem / 16);
            border-bottom: 1px dashed silver;
            line-height: calc(30rem / 16);
            color: #000;

            .value {
              color: #606266;
              line-height: calc(30rem / 16);
              padding: 0 calc(15rem / 16);
            }
          }

          &_item:last-child {
            border-bottom-width: 0;
          }
        }
      }
    }

    .btn {
      position: fixed;
      bottom: calc(20rem / 16);
      left: calc(20rem / 16);
      right: calc(20rem / 16);
      background: #f96;
      border: none;
      height: calc(50rem / 16);
      border-radius: calc(8rem / 16);
      color: var(--white);
      text-align: center;
      line-height: calc(50rem / 16);
      font-size: var(18rem / 16);
    }
  }
}
</style>